import DDT from "disable-devtool";
const version = process.env.PACKAGE_VERSION;
const htmlSrc = `
<!DOCTYPE html>
<html lang="zh-CN">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Debugging Mode Alert</title>
    <style>
     html {
          position: static !important;
        }

      body {
            display: flex;
            justify-content: center;
            align-items: center;
            min-height: 100vh;
            margin: 0;
            padding: 1rem;
            background: linear-gradient(135deg, #6b6966, #4d4844);
            box-sizing: border-box;
        }

        .debug-warning {
            display: flex;
            align-items: center;
            background: linear-gradient(135deg, #ff9900cb, #e7a35e);
            color: white;
            padding: 1.5rem 2rem;
            margin: 1rem 0;
            border-radius: 8px;
            box-shadow: 0 4px 12px rgba(245, 124, 0, 0.3);
            font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
            max-width: 600px;
            animation: pulse 2s infinite ease-in-out;
        }

        /* 其他样式保持不变 */
        .warning-icon {
            font-size: 2.5rem;
            margin-right: 1.5rem;
            background-color: rgba(255, 255, 255, 0.2);
            width: 60px;
            height: 60px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-shrink: 0;
        }

        .warning-content {
            flex-grow: 1;
        }

        .warning-title {
            font-size: 1.6rem;
            font-weight: bold;
            margin-bottom: 0.5rem;
        }

        .warning-text {
            font-size: 1.4rem;
            line-height: 1.5;
            opacity: 0.9;
        }

        @keyframes pulse {
            0% {
                transform: scale(1);
                box-shadow: 0 4px 12px rgba(245, 124, 0, 0.3);
            }

            50% {
                transform: scale(1.02);
                box-shadow: 0 6px 16px rgba(245, 124, 0, 0.4);
            }

            100% {
                transform: scale(1);
                box-shadow: 0 4px 12px rgba(245, 124, 0, 0.3);
            }
        }

        /* 响应式设计 */
        @media (max-width: 480px) {
            .debug-warning {
                padding: 1rem;
                flex-direction: column;
                text-align: center;
            }

            .warning-icon {
                margin-right: 0;
                margin-bottom: 1rem;
            }
        }
    </style>
</head>
<body>
    <div class="debug-warning">
        <div class="warning-icon">⚠️</div>
        <div class="warning-content">
            <div class="warning-title">Debug Mode Warning</div>
            <div class="warning-text">Please close debug mode before browsing this webpage. Debug mode may affect page
                performance and functionality.</div>
        </div>
    </div>
</body>
</html>`;
// console.log("DDT", DDT.md5(version), version);
const disableDevtool = {
  install(Vue, options) {
    // 默认配置
    const defaultOptions = {
      md5: DDT.md5(version), // 32位md5值，用于校验页面内容是否被修改
      url: "", // 检测到开发者工具时跳转的URL
      timeOutUrl: "", // 超时跳转URL
      tkName: "123456789", // 校验密钥名称
      ondevtoolopen: function (type, next) {
        console.log("开发者工具已打开", type);
        // 先尝试调用内置关闭逻辑
        try {
          next && next();
        } catch (e) {
          console.error("尝试关闭调试模式失败:", e);
        }

        // 延时再次确认（兜底检测）
        setTimeout(() => {
          if (
            window.outerHeight - window.innerHeight > 200 ||
            window.outerWidth - window.innerWidth > 200
          ) {
            // 覆盖整个页面为你的警告 HTML
            document.open();
            document.write(htmlSrc); // 这里用你定义的警告 HTML
            document.close();
          }
        }, 500);

        // next && next(); // 如果有next函数，执行它
      }, // 开发者工具打开时的回调

      // ondevtoolclose: function (type) {
      //   // console.log("开发者工具已关闭", type);
      // }, // 开发者工具关闭时的回调
      interval: 1000, // 检测间隔(ms)
      disableMenu: true, // 禁用右键菜单
      stopIntervalTime: 1000, // 移动端停止检测的时间(ms)
      clearIntervalWhenDevOpenTrigger: false, // 是否在触发之后停止监控
      detectors: "all", // 启用的监测器 默认为全部
      clearLog: true, // 是否清除控制台日志
      disableSelect: false, // 是否禁用选择文本 默认为false
      disableCopy: false, // 是否禁用复制 默认为false
      disableCut: false, // 是否禁用剪切 默认为false
      disablePaste: false, // 是否禁用粘贴 默认为false
      ignore: false, // 某些情况忽略禁用
      disableIframeParents: false, // iframe中是否禁用所有父窗口，默认 true
      seo: true, // 是否启用对seo进行保护，默认 true
      rewriteHTML: "", // 检测到打开之后重写页面
      // detach: false, // 是否离开当前页面
      // clearIntervalOnDevOpen: true, // 检测到开发者工具后是否停止检测
      // logMaxLength: 300, // 控制台日志最大长度
      // redirect: function (url) {}, // 自定义重定向函数
      // debug: false, // 是否开启调试模式
    };
    // 合并配置
    const finalOptions = { ...defaultOptions, ...options };
    // 初始化
    DDT(finalOptions);
    // 添加到Vue原型（可选）
    // Vue.prototype.$disableDevtool = DDT;
  },
};
export default disableDevtool;
